module.exports = __webpack_public_path__ + "media/images/icon_youtube-3af83957eed24560a94489c6be303ffa.svg";